import { render, staticRenderFns } from "./UserAccessRequest.vue?vue&type=template&id=442e4b7c&scoped=true&"
import script from "./UserAccessRequest.vue?vue&type=script&lang=js&"
export * from "./UserAccessRequest.vue?vue&type=script&lang=js&"
import style0 from "./UserAccessRequest.vue?vue&type=style&index=0&id=442e4b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442e4b7c",
  null
  
)

export default component.exports